import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import '@/assets/style.css'  // مسیر نسبی از محل فایل

import router from './router'

createApp(App).use(router).mount('#app')
